import { ArrowDownUp } from 'lucide-react';

import { SORT_LABELS } from '@shared/schemas/pagination';

/**
 * The order control above a list — owner request, 2026-08-10.
 *
 * **A select rather than clickable column headers**, for the reason recorded in
 * `pagination.ts`: `DataTable` becomes cards below 768px and a card has no
 * headers, so headers would mean no sorting at all on a phone. This sits above
 * the list and works on both layouts.
 *
 * **A select rather than more `FilterPills`**, because the row above these
 * lists is already pills, and a second row of pills that changes the order
 * rather than the contents reads as another filter. Different job, different
 * control.
 */
export function SortSelect<Value extends keyof typeof SORT_LABELS>({
  options,
  value,
  onChange,
  label,
}: {
  options: readonly Value[];
  value: Value;
  onChange: (value: Value) => void;
  /** What is being ordered. "Sort clients". */
  label: string;
}) {
  return (
    <label className="flex items-center gap-2">
      <span className="sr-only">{label}</span>
      <ArrowDownUp aria-hidden="true" className="size-4 shrink-0 text-ink-500" />
      <select
        value={value}
        onChange={(event) => {
          onChange(event.target.value as Value);
        }}
        className="min-h-control rounded-sm border border-ink-300 bg-white px-3 text-body"
      >
        {options.map((option) => (
          <option key={String(option)} value={String(option)}>
            {SORT_LABELS[option]}
          </option>
        ))}
      </select>
    </label>
  );
}
